import { render, staticRenderFns } from "./Zxxg.vue?vue&type=template&id=bd2d9a80&scoped=true&"
import script from "./Zxxg.vue?vue&type=script&lang=js&"
export * from "./Zxxg.vue?vue&type=script&lang=js&"
import style0 from "./Zxxg.vue?vue&type=style&index=0&id=bd2d9a80&lang=less&scoped=true&"
import style1 from "./Zxxg.vue?vue&type=style&index=1&id=bd2d9a80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d9a80",
  null
  
)

export default component.exports